import { call, put, takeLatest } from "redux-saga/effects";
import { OP } from "../../constant";
import {
  doListTarrifs,
  doCreateTarrif,
  doUpdateTarrif,
  doDeleteTarrif,
} from "../../service/tarrif";

import errorMessage from "../../utils/error.json";

/* ------------------------- TARRIF SAGA --------------------- */
// list tarrifs
function* listTarrifTask(action) {
  try {
    yield put({ type: OP.LIST_TARRIF_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doListTarrifs,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.LIST_TARRIF_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.LIST_TARRIF_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.LIST_TARRIF_FAILURE,
      payload: errMsg,
    });
  }
}

// create tarrif
function* createTarrifTask(action) {
  try {
    yield put({ type: OP.CREATE_TARRIF_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doCreateTarrif,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.CREATE_TARRIF_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.CREATE_TARRIF_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.CREATE_TARRIF_FAILURE,
      payload: errMsg,
    });
  }
}

// update tarrif
function* updateTarrifTask(action) {
  try {
    yield put({ type: OP.UPDATE_TARRIF_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doUpdateTarrif,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.UPDATE_TARRIF_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.UPDATE_TARRIF_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.UPDATE_TARRIF_FAILURE,
      payload: errMsg,
    });
  }
}

// delete tarrif
function* deleteTarrifTask(action) {
  try {
    yield put({ type: OP.DELETE_TARRIF_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doDeleteTarrif,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.DELETE_TARRIF_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.DELETE_TARRIF_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.DELETE_TARRIF_FAILURE,
      payload: errMsg,
    });
  }
}

function* tarrifSaga() {
  yield takeLatest(OP.LIST_TARRIF_REQUEST, listTarrifTask);
  yield takeLatest(OP.CREATE_TARRIF_REQUEST, createTarrifTask);
  yield takeLatest(OP.UPDATE_TARRIF_REQUEST, updateTarrifTask);
  yield takeLatest(OP.DELETE_TARRIF_REQUEST, deleteTarrifTask);
}

export default tarrifSaga;
